module.exports = __webpack_public_path__ + "static/media/minus.137cec96.svg";